import { useAtom } from 'jotai';
import { IconBell } from '@optiaxiom/icons';
import { Button, Indicator } from '@optiaxiom/react';

import { activeRightSidebarAtom } from '@frontend/atoms';
import { useBadgeCount, useNotificationTracking } from '@frontend/features/notifications/hooks';
import { formatUnreadCount } from '@frontend/features/notifications/utils';

export function NotificationBellButton() {
  const [activeRightSidebar, setActiveRightSidebar] = useAtom(activeRightSidebarAtom);
  const { trayViewed } = useNotificationTracking();

  const { data: badgeCount } = useBadgeCount({ grouped: true });

  const badgeContent = formatUnreadCount(badgeCount);

  return (
    <Button
      appearance="subtle"
      aria-label="Notifications"
      icon={
        <Indicator content={badgeContent} disabled={!badgeContent} intent="danger" variant="strong">
          <IconBell />
        </Indicator>
      }
      onClick={() => {
        const opening = activeRightSidebar !== 'notifications';
        if (opening) {
          trayViewed(badgeCount ?? 0);
        }
        setActiveRightSidebar(opening ? 'notifications' : null);
      }}
      size="lg"
      square
    />
  );
}
